import React from 'react';
import { ErrorMessage } from 'formik';
import { styled } from 'linaria/react';
import { InputHelperText } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
const InputErrorMessage = ({
  name
}) => <ErrorMessage name={name} render={ErrorHelperText} />;
const ErrorHelperText = message => <CustomInputHelperText hasError>{message}</CustomInputHelperText>;
const _exp = /*#__PURE__*/() => InputHelperText;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.error;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxxs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxs;
const CustomInputHelperText = withTheme(/*#__PURE__*/styled(_exp())({
  name: "CustomInputHelperText",
  class: "cs2ijnq",
  propsAsIs: true,
  vars: {
    "cs2ijnq-0": [_exp2()],
    "cs2ijnq-1": [_exp3()],
    "cs2ijnq-2": [_exp4(), "px"],
    "cs2ijnq-3": [_exp5(), "px"]
  }
}));
export default InputErrorMessage;

require("./InputErrorMessage.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./InputErrorMessage.tsx");